export enum AccountRequestStatuses {
  FinishOwnerInformation = 'Finish Owner Information',
  FinishBeneficiaries = 'Finish Beneficiaries',
  FinishAdditionalInformation = 'Finish Additional Information',
  FinishReview = 'Finish Review',
  PendingVerification = 'Pending Verification',
  PendingAccountOpening = 'Pending Account Opening',
  Linked = 'Linked',
  Cancelled = 'Cancelled',
  Error = 'Error',
  RequestSubmitted = 'Request Submitted',
}

export enum AccountRequestStatusId {
  FinishOwnerInformation = 1,
  FinishBeneficiaries = 2,
  FinishAdditionalInformation = 3,
  FinishReview = 4,
  PendingVerification = 5,
  PendingAccountOpening = 7,
  Linked = 8,
  Cancelled = 9,
  Error = 10,
  RequestSubmitted = 11,
}
